import { APP_NAME } from '@/constants/stringVars';

const onboardingMessages = {
  memberCareOnboardingTitle: `We’re delighted to have you onboard.`,
  userOnboardingDescription: `We invite you to join us and let ${APP_NAME} help your organization with everything related to mental health.`,
  proceed: 'Proceed',
  yourEmailAddress: 'Your email address',
  emailSuccessfullyVerified: 'You have successfully verified your email.',
  emailNotVerifiedSuccessfully: 'Wrong credentials or expired token',
  checkEmailOrContactAdmin: 'Please check your email or contact your administrator.',
  createYourPassword: 'Next, create your password.',
  passwordSetupUnsuccessful: 'Password setup unsuccessful.',
  passwordMustContain: 'Password must contain:',
  password8chars: '8+ characters',
  passwordLowercase: '1 lowercase letter',
  passwordUppercase: '1 uppercase letter',
  passwordNumberOrSpecialChar: '1 number or special character',
  listItemDot: '•',
  iAgreeTo: 'I agree to',
  termsOfUse: 'Terms of Use',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  termsOfInfoTooltip: `By checking this box, you acknowledge that you’ve read and agreed to ${APP_NAME}’s User Agreement, Privacy Policy, and Community Standards, and you consent to the collection and use of your information as described in those documents.`,
  yourStoryMatters: 'Your story matters.',
  yourStoryMattersDescription:
    'We ask a few personal details so we can better understand you — and guide your journey with resources that fit who you are. \n\nYour information stays private and is used only to personalize your experience and support your growth within the MyOmnia Wholeness Platform and community.',
  memberCareOnboardingDescription: `It is a great pleasure to have one more Member Care Coordinators at ${APP_NAME}.`,
  goBack: 'Go back',
  continue: 'Continue',
};

export default onboardingMessages;
